// extracted by mini-css-extract-plugin
module.exports = {"berbix__container":"dive_berbix__container__O2EpS","berbix_buttons":"dive_berbix_buttons__2YGXI"};